<template>
  <div class="ly-table">
    <div class="ly-title">
      <h3 class="title-table">
        <slot></slot>
      </h3>
      <idc-breadcrumb :breadcrumbList="breadcrumbList" />
      <idc-workflow type="A" :workFlowListStep="flowWorkflowStatus" />
    </div>
    <div class="detail" :style="zoomData">
      <div class="detail-row">
        <div
          class="detail-col"
          v-for="(step, index) in workFlowList"
          :key="index"
        >
          <div class="step">
            <div class="step-title">
              <wrk-workflow :workFlowList="step" :flowDepth="step" />
            </div>
            <ul class="step-frame">
              <li
                class="step-stack"
                v-for="(step, index) in step.twoDepth"
                :key="index"
              >
                <wrk-workflow :workFlowList="step" :flowDepth="step" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WrkWorkflow from "@/components/idcUsageStatus/requestStatus/wrkComponents/defaultComponents/WrkWorkflow.vue";
import IdcBreadcrumb from "@/components/common/IdcBreadcrumb";
import IdcWorkflow from "@/components/common/IdcWorkflow.vue";

export default {
  components: {
    IdcBreadcrumb,
    IdcWorkflow,
    WrkWorkflow,
  },
  props: {
    zoomData: {
      type: Object,
      default: () => {},
    },
    breadcrumbList: {
      type: Array,
      default: () => [],
    },
    flowWorkflowStatus: {
      type: Array,
      default: () => [],
    },
    workFlowList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    getFlowStatus() {
      return this.flowWorkflowStatus;
    },
  },
  method: {
    clickFlow() {},
  },
};
</script>

<style lang="scss" scoped>
.detail {
  &-row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 14.07px;
    padding: 0 0 12px 0;
    overflow: auto;
  }
  &-col {
    flex: 1 0 auto;
  }
}
.step {
  width: 100%;
  &-title,
  &-stack {
    width: 100%;
    .work-flow {
      width: 100% !important;
    }
  }
  &-frame {
    padding-top: 10px;
    position: relative;
    &::before {
      content: "";
      display: inline-block;
      width: 1px;
      height: 10px;
      background-color: $--border-color-base;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      clear: both;
    }
  }
  &-stack {
    &:not(:first-child) {
      margin-top: 5px;
    }
  }
}
</style>
